module.exports = __webpack_public_path__ + "img/qrcode_bg.10a137ba.png";